import { ITerm } from "@evennt-tech/api-v2-core";
import { isLinkedTerm } from "api/showInfoLibrary/types";

type LibraryRole = {
  /** Whether the organiser may change library links — Organiser Admin. */
  isCompanyAdmin: boolean;
  /** Whether `isCompanyAdmin` means anything yet; it is fetched. */
  isRoleResolved: boolean;
};

/**
 * Whether the section's form opens from the card. A local one always; a linked
 * one only for an Organiser Admin, since everything left in that form —
 * `Unlink`, `Remove`, the build-type filter — is theirs (Roles/ACL).
 *
 * An unresolved role counts as allowed: it reads `false` until the organiser is
 * fetched, and locking on that ate the first click on a cold page.
 */
const canOpenSectionForm = (
  term: ITerm,
  { isCompanyAdmin, isRoleResolved }: LibraryRole
): boolean => !isLinkedTerm(term) || !isRoleResolved || isCompanyAdmin;

export default canOpenSectionForm;
